import { queryOptions } from "@tanstack/react-query";
import { z } from "zod";

import { apiKeyPath, apiKeysSchema, apiPaths, createdApiKeySchema, type CreatedApiKey } from "@ravnar/api-contract";

import { apiRequest } from "./client";
import { LIST_STALE_TIME_MS } from "./refresh";

// The organization's API keys. They are a setting, so their key starts with "settings" and a save anywhere in the
// settings refreshes them too.

/**
 * The organization's API keys, the oldest first; only owners and admins may read them. Software marks a key used with
 * every request it makes, so the list is asked for again whenever the page is opened.
 */
export const apiKeysQueryOptions = () =>
	queryOptions({
		queryKey: ["settings", "api-keys"],
		queryFn: ({ signal }) => apiRequest(apiPaths.apiKeys, apiKeysSchema, { signal }),
		staleTime: LIST_STALE_TIME_MS,
	});

/** Creates a key named `name`, and answers it with the key itself — which the API never sends again. */
export function createApiKey(name: string): Promise<CreatedApiKey> {
	return apiRequest(apiPaths.apiKeys, createdApiKeySchema, { method: "POST", body: { name } });
}

/** Revokes a key: software using it is refused from its next request on. */
export async function revokeApiKey(keyId: string): Promise<void> {
	await apiRequest(apiKeyPath(keyId), z.undefined(), { method: "DELETE" });
}
